const getters = {
  language: state => state.app.language,
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  historyList: state => state.app.historyList
}
export default getters
